export default __webpack_public_path__ + "static/media/0x3642c3c8ebe0b36a29e37809e1c9a7de06bc0b26.76fd30ab.webp";